var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-row',{attrs:{"gutter":[16,16],"type":"flex","align":"middle","justify":"center"}},[_c('a-col',[_c('login-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }